import {disablesChildren} from '@formkit/inputs'
import {outerFragment} from "~/libs/formkit/utils";
import './group.scss'


const groupFragment = outerFragment({
  attrs: {
    'data-variant': "$variant || 'default'",
  }
})

/**
 * Input definition for a group.
 * @public
 */
export const group = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: groupFragment('$slots.default'),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'group',
  /**
   * An array of extra props to accept for this input.
   */
  props: ['variant'],
  /**
   * Additional features that should be added to your input
   */
  features: [disablesChildren],
}
